class MiniCrmFormHandler {
  constructor({ form, endpoint, formHash }) {
    this.form = form;
    this.endpoint = endpoint;
    this.formHash = formHash;
    this.fields = {
      email: form.querySelector("#Contact_Email_3575"),
      lastName: form.querySelector("#Contact_LastName_3575"),
      phone: form.querySelector("#Contact_Phone_3575"),
      dimensions: form.querySelector("#Project_Text2553_3573"),
      application: form.querySelector("#Project_Text2554_3573"),
      color: form.querySelector("#Project_Text2555_3573"),
      notes: form.querySelector("#Project_Text2556_3573")
    };
  }

  getInputValue(field) {
    if (!field) {
      return "";
    }

    return field.value.trim();
  }

  getSelectText(select) {
    if (!select || !select.value) {
      return "";
    }

    const option = select.selectedOptions[0];
    return option ? option.textContent.trim() : "";
  }

  appendIfValue(data, key, value) {
    const stringValue = String(value ?? "").trim();

    if (stringValue !== "") {
      data.append(key, stringValue);
    }
  }

  buildFormData() {
    const data = new FormData();

    this.appendIfValue(data, "Contact[3575][Email]", this.getInputValue(this.fields.email));
    this.appendIfValue(data, "Contact[3575][LastName]", this.getInputValue(this.fields.lastName));
    this.appendIfValue(data, "Contact[3575][Phone]", this.getInputValue(this.fields.phone));
    this.appendIfValue(data, "Project[3573][Text2553]", this.getInputValue(this.fields.dimensions));
    this.appendIfValue(data, "Project[3573][Text2554]", this.getInputValue(this.fields.application));
    this.appendIfValue(data, "Project[3573][Text2555]", this.getSelectText(this.fields.color));
    this.appendIfValue(data, "Project[3573][Text2556]", this.getInputValue(this.fields.notes));

    data.append("Dummy[][GDPR_Contribution][]", "1");
    data.append("Referrer", window.location.href);
    data.append("FormHash", this.formHash);

    return data;
  }

  async submit() {
    const payload = this.buildFormData();

    await fetch(this.endpoint, {
      method: "POST",
      mode: "no-cors",
      body: payload
    });
  }
}

(() => {
  const modal = document.querySelector("[data-banda-modal]");
  const openButton = document.querySelector("[data-banda-modal-open]");
  const closeButtons = document.querySelectorAll("[data-banda-modal-close]");
  const form = document.querySelector("[data-banda-form]");
  const status = document.querySelector("[data-banda-status]");
  const success = document.querySelector("[data-banda-success]");
  const submitButton = form?.querySelector(".banda-form__submit");
  const formHash = form?.getAttribute("formhash") ?? "";
  let lastFocusedElement = null;
  let closeTimer = null;
  let wasSubmitted = false;

  if (!modal || !openButton) {
    return;
  }

  const miniCrmHandler = form
    ? new MiniCrmFormHandler({
        form,
        endpoint: form.action,
        formHash
      })
    : null;

  const openModal = () => {
    window.clearTimeout(closeTimer);
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    window.requestAnimationFrame(() => {
      modal.classList.add("banda-modal--open");
      modal.querySelector(".banda-modal__close")?.focus();
    });
  };

  const closeModal = () => {
    modal.classList.remove("banda-modal--open");
    document.body.style.overflow = "";
    closeTimer = window.setTimeout(() => {
      modal.hidden = true;
      lastFocusedElement?.focus?.();
    }, 280);
  };

  const getFieldMessage = (input) => {
    const value = input.value.trim();

    if (input.required && !value) {
      return "Completează acest câmp.";
    }

    if (input.type === "email" && value && !input.validity.valid) {
      return "Introdu o adresă de email validă.";
    }

    if (input.type === "tel" && value && value.replace(/\D/g, "").length < 10) {
      return "Introdu un număr de telefon valid.";
    }

    return "";
  };

  const validateField = (input) => {
    const field = input.closest("[data-banda-field]");
    const error = field?.querySelector("[data-banda-error]");
    const message = getFieldMessage(input);

    field?.classList.toggle("banda-form__field--invalid", Boolean(message));
    input.setAttribute("aria-invalid", String(Boolean(message)));

    if (error) {
      error.textContent = message;
    }

    return !message;
  };

  const validateForm = () => {
    if (!form) {
      return true;
    }

    const inputs = [...form.querySelectorAll("input, select")];
    let isValid = true;

    inputs.forEach((input) => {
      if (!validateField(input)) {
        isValid = false;
      }
    });

    return isValid;
  };

  const setLoading = (isLoading) => {
    if (!submitButton) {
      return;
    }

    submitButton.disabled = isLoading;
    submitButton.classList.toggle("banda-form__submit--loading", isLoading);
  };

  const showSuccess = () => {
    form?.querySelector(".banda-form__panel")?.setAttribute("hidden", "");
    form?.querySelector(".banda-form__notice")?.setAttribute("hidden", "");
    submitButton?.setAttribute("hidden", "");

    if (status) {
      status.textContent = "";
    }

    if (success) {
      success.hidden = false;
    }
  };

  openButton.addEventListener("click", openModal);

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeModal);
  });

  form?.addEventListener("submit", async (event) => {
    event.preventDefault();
    wasSubmitted = true;

    if (status) {
      status.textContent = "";
      status.classList.remove("banda-form__status--error");
    }

    if (!validateForm()) {
      form.querySelector(".banda-form__field--invalid input, .banda-form__field--invalid select")?.focus();
      return;
    }

    setLoading(true);

    try {
      await miniCrmHandler?.submit();
      form.reset();
      showSuccess();
    } catch (error) {
      console.error("MiniCRM submit failed:", error);

      if (status) {
        status.textContent = "Trimiterea nu a reușit. Te rugăm să încerci din nou.";
        status.classList.add("banda-form__status--error");
      }

      setLoading(false);
    }
  });

  form?.addEventListener("input", (event) => {
    if (!wasSubmitted || !(event.target instanceof HTMLInputElement)) {
      return;
    }

    validateField(event.target);
  });

  form?.addEventListener("change", (event) => {
    if (!wasSubmitted || !(event.target instanceof HTMLSelectElement)) {
      return;
    }

    validateField(event.target);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) {
      closeModal();
    }
  });
})();
